module.exports = __webpack_public_path__ + "img/logoMomo.9856ce40.svg";